import { NgModule } from "@angular/core";
import { SurveyDetailsComponent } from "./survey-details.component";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ContentRoutingModule } from "../content-routing.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MaterialModule } from "src/app/material.module";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { SharedTranslateModule } from "src/app/shared-translate.module";
import { SpinnerModule } from "src/app/spinner.module";
import { PipesModule } from "src/app/pipes.module";
import { UploadImageModule } from "src/app/upload-image.module";
import { SurveyAutocompleteModule } from "src/app/survey-autocomplete.module";
import { CommService } from "src/services/comm-service";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule,
        MaterialModule,
        PerfectScrollbarModule,
        SharedTranslateModule,
        SpinnerModule,
        PipesModule,
        UploadImageModule,
        SurveyAutocompleteModule,
    ],
    declarations: [
        SurveyDetailsComponent
    ],
    entryComponents: [
        SurveyDetailsComponent
    ],
    providers: [
        CommService
    ],
    exports: [
        SurveyDetailsComponent
    ]
})
export class SurveyDetailsModule { }